import { render, staticRenderFns } from "./AuthorizedPersonForm.vue?vue&type=template&id=d935760c&"
import script from "./AuthorizedPersonForm.vue?vue&type=script&lang=js&"
export * from "./AuthorizedPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports